import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// Styles
import './Confirm.css';
// Intl
import { FormattedMessage, injectIntl } from "react-intl";
// Actions
import { resetState } from '../../actions/actionCreators';

class Confirm extends React.Component {

    componentDidMount() {
        let inquiryData = this.props.inquiryData;

        if (Object.keys(inquiryData).length !== 0) {
            let payload = this.mapToPayload(inquiryData);
            let body  = JSON.stringify(payload)

            let headers = new Headers({
                'Content-Type': 'application/json'
            });

            fetch("https://otg-privacy-api.azurewebsites.net/api/email/", {
                method: 'POST',
                headers,
                body
            }).then(response => {
                if (response.ok)
                    setTimeout(() => {
                        console.log('mail sent!')
                    }, 1000);
            }).catch((e) => {})
        }
    }

    deleteState() {
        this.props.resetState();
    }

    render() {
        return (
            <div className="confirm">
                <h2 className="confirm-heading">
                    <FormattedMessage id="confirmTitle" defaultMessage="Title" />
                </h2>
                <p><FormattedMessage id="confirmInfoFirst" defaultMessage="Infofirst" /></p>
                <p><FormattedMessage id="confirmInfoSecond" defaultMessage="Infosecond" />
                    <a rel="noopener noreferrer" href="https://thon.no/om/personvern/" target="_blank">thon.no/om/personvern/</a>
                </p>
                <div className="submit-wrapper">
                    <Link className="link-button" to='/' onClick={this.deleteState.bind(this)}>
                        <button><FormattedMessage id="confirmSubmit" defaultMessage="Submit" /></button>
                    </Link>
                </div>
            </div>
        );
    }

    mapToPayload(inquiryData, targetSystems) {
        return {
            type: inquiryData.inquiryType.apiName,
            inquiry: inquiryData.inquiry,
            isPrivacyConsent: inquiryData.isPrivacyConsent,
            contact: inquiryData.contact,
            targetSystems: this.props.targetSystems.map(x => ({
                title: x.apiName,
                include: inquiryData.targetSystems.includes(x.id)}))
        };
    }
}

let mapStateToProps = state => ({
    inquiryData: state.inquiryData,
    targetSystems: state.targetSystems
});

export default injectIntl(connect(mapStateToProps, { resetState })(Confirm));
